module.exports = __webpack_public_path__ + "img/组 5@2x.406218ca.png";